module.exports = __webpack_public_path__ + "static/media/image1.65fa559a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/image1.png
// module id = 1255
// module chunks = 0